<template>
  <nav class="navbar p-0 navbar-light justify-content-between flex-nowrap flex-row fixed-top">
    <div class="container-fuild w-100">
      <router-link :to="{ name: 'top', params: {} }" class="navbar-brand">
        <img src="~assets/photo_spot_international_header_logo.png" class="img-fluid">
      </router-link>
      <header-right-menu-mobile @logout="logout" iconSizeClass="fa-3x" headerHeight="50" />
    </div>
  </nav>
</template>
<script>
  import {dd,store,app} from 'systems/imports'
  import HeaderRightMenuMobile from 'components/global/partials/HeaderRightMenuMobile.vue'

  export default {
    name:"",
    components: {
      HeaderRightMenuMobile,
    },
    data () {
      return {
      }
    },
    mounted(){
      this.$nextTick(()=>{
        app.make("adjustLayout")()
      })
    },
    methods:{
      logout(){
        this.$emit('logout')
      }
    }
  }
</script>


<style lang="scss" scoped>
  .navbar {
    background-size: 10% auto;
    background-color: #fcd599;
    .navbar-brand {
      width: 50%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
    }
  }
</style>



// WEBPACK FOOTER //
// MobileHeader.vue?54be8540